import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Header() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  
  const isActive = (path) => {
    return location.pathname === path ? "active" : "";
  };

  const toggleMenu = () => {
    const newState = !isMenuOpen;
    setIsMenuOpen(newState);
    if (newState) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      setOpenDropdown(null);
    }
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setOpenDropdown(null);
    document.body.style.overflow = '';
  };

  const toggleDropdown = (dropdownName, e) => {
    e.preventDefault();
    setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
  };

  const languages = [
    { name: "German", id: "german", flag: "🇩🇪" },
    { name: "Spanish", id: "spanish", flag: "🇪🇸" },
    { name: "Japanese", id: "japanese", flag: "🇯🇵" },
    { name: "Korean", id: "korean", flag: "🇰🇷" },
    { name: "French", id: "french", flag: "🇫🇷" },
  ];

  const services = [
    { name: "B2B Language Solutions", id: "b2b-language-solutions" },
    { name: "Professional Interpretation", id: "professional-interpretation" },
    { name: "Translation Services", id: "translation-services" },
    { name: "Editing & Content Moderation", id: "editing-content-moderation" },
    { name: "Transcription & Subtitling", id: "transcription-subtitling" },
    
  ];

  return (
    <>
      {isMenuOpen && (
        <div 
          className="menu-overlay"
          onClick={closeMenu}
          aria-hidden="true"
        />
      )}
      <header className={`header ${isMenuOpen ? 'menu-open' : ''}`}>
        <nav className="nav">
        <div className="logo">
          <Link to="/" onClick={closeMenu}>
            <img
              src="https://ucarecdn.com/c1c1dab1-1119-49ef-b9b2-a918dd005127/-/format/auto/"
              alt="University of Languages Logo"
              style={{ height: '4rem', width: 'auto' }}
            />
          </Link>
        </div>
        <button 
          className="hamburger-menu"
          onClick={toggleMenu}
          aria-label="Toggle menu"
          aria-expanded={isMenuOpen}
        >
          <span className={`hamburger-line ${isMenuOpen ? 'active' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'active' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'active' : ''}`}></span>
        </button>
        <div className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
          <Link to="/" className={isActive("/")} onClick={closeMenu}>
            Home
          </Link>
          <div className={`nav-dropdown ${openDropdown === 'courses' ? 'open' : ''}`}>
            <Link 
              to="/courses" 
              className={isActive("/courses")} 
              onClick={(e) => {
                if (window.innerWidth < 768) {
                  toggleDropdown('courses', e);
                } else {
                  closeMenu();
                }
              }}
            >
              Courses
              <span className="dropdown-icon"></span>
            </Link>
            <div className="dropdown-menu">
              {languages.map((lang) => (
                <Link
                  key={lang.id}
                  to={`/courses#${lang.id}`}
                  className="dropdown-item"
                  onClick={closeMenu}
                >
                  <span className="dropdown-flag">{lang.flag}</span>
                  <span>{lang.name}</span>
                </Link>
              ))}
            </div>
          </div>
          <div className={`nav-dropdown ${openDropdown === 'services' ? 'open' : ''}`}>
            <Link 
              to="/services" 
              className={isActive("/services")} 
              onClick={(e) => {
                if (window.innerWidth < 768) {
                  toggleDropdown('services', e);
                } else {
                  closeMenu();
                }
              }}
            >
              Services
              <span className="dropdown-icon"></span>
            </Link>
            <div className="dropdown-menu services-dropdown">
              {services.map((service) => (
                <Link
                  key={service.id}
                  to={`/services#${service.id}`}
                  className="dropdown-item"
                  onClick={closeMenu}
                >
                  <span>{service.name}</span>
                </Link>
              ))}
            </div>
          </div>
          <Link to="/features" className={isActive("/features")} onClick={closeMenu}>
            Features
          </Link>
          <Link to="/about" className={isActive("/about")} onClick={closeMenu}>
            About
          </Link>
          <Link to="/contact" className={isActive("/contact")} onClick={closeMenu}>
            Contact
          </Link>
          <Link to="/contact" className="cta-button mobile-cta" onClick={closeMenu}>Enroll Now</Link>
        </div>
        <Link to="/contact" className="cta-button desktop-cta">Enroll Now</Link>
      </nav>
    </header>
    </>
  );
}
